import React from 'react';
import { 
    ScatterChart, 
    Scatter, 
    XAxis, 
    YAxis, 
    ZAxis, 
    CartesianGrid, 
    Tooltip, 
    ResponsiveContainer,
    Cell,
    Label,
    ReferenceLine
} from 'recharts';
import { Users, AlertCircle, Zap, Target } from 'lucide-react';
import '../EvaluationDesign.css';

/**
 * Team4Box Component
 * Original SIRH Professional version
 */
const Team4Box = ({ teamData, onUserSelect }) => {
    
    // Process team data
    const plottedData = (teamData || []).map(user => {
        const levels = user.niveaux || [];
        if (levels.length === 0) return null;

        const avgObtenu = infoAverage(levels, 'scoreObtenu', 'scoreManager', 'scoreCollab');
        const avgRequis = infoAverage(levels, 'scoreRequis');

        return {
            id: user.id,
            name: user.userFullName || user.nom,
            x: avgObtenu,
            y: avgRequis,
            userObj: user
        };
    }).filter(Boolean);

    if (plottedData.length === 0) {
        return (
            <div className="eval-empty">
                <h3>Matrice d'Équipe</h3>
                <p>Aucune donnée disponible pour projeter l'équipe.</p>
            </div>
        );
    }

    const CustomTooltip = ({ active, payload }) => {
        if (active && payload && payload.length) {
            const data = payload[0].payload;
            return (
                <div className="eval-card" style={{ padding: '10px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }}>
                    <p style={{ fontWeight: 700, fontSize: '12px', margin: 0, color: '#204385' }}>{data.name}</p>
                    <p style={{ fontSize: '10px', margin: '4px 0 0', color: '#64748b' }}>Maîtrise: {data.x.toFixed(2)} | Requis: {data.y.toFixed(2)}</p>
                </div>
            );
        }
        return null;
    };

    return (
        <div className="team4box-container">
            <div className="eval-card" style={{ padding: '20px', position: 'relative' }}>
                <ResponsiveContainer width="100%" height={450}>
                    <ScatterChart margin={{ top: 20, right: 30, bottom: 40, left: 20 }}>
                        <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" />
                        
                        <XAxis type="number" dataKey="x" domain={[0, 4]} tickCount={5} stroke="#94a3b8" fontSize={11}>
                            <Label value="Moyenne Maîtrise" offset={-20} position="insideBottom" fill="#475569" fontWeight={600} fontSize={12} />
                        </XAxis>
                        
                        <YAxis type="number" dataKey="y" domain={[0, 4]} tickCount={5} stroke="#94a3b8" fontSize={11}>
                            <Label value="Moyenne Exigence" angle={-90} position="insideLeft" style={{ textAnchor: 'middle' }} fill="#475569" fontWeight={600} fontSize={12} />
                        </YAxis>
                        
                        <ZAxis type="number" range={[150, 150]} />
                        <Tooltip content={<CustomTooltip />} />
                        
                        <ReferenceLine x={2.5} stroke="#e2e8f0" strokeWidth={2} />
                        <ReferenceLine y={2.5} stroke="#e2e8f0" strokeWidth={2} />

                        <Scatter name="Collaborateurs" data={plottedData} onClick={(data) => onUserSelect && onUserSelect(data.userObj)}>
                            {plottedData.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={entry.x >= 2.5 ? '#204385' : '#ee645f'} style={{ cursor: 'pointer' }} />
                            ))}
                        </Scatter>
                    </ScatterChart>
                </ResponsiveContainer>
                
                {/* Labels Overlay */}
                <div style={{ position: 'absolute', top: '30px', left: '70px', right: '40px', bottom: '70px', pointerEvents: 'none', display: 'grid', gridTemplateColumns: '1fr 1fr', gridTemplateRows: '1fr 1fr' }}>
                    <div style={{ color: '#ee645f', fontSize: '10px', fontWeight: 700, padding: '10px' }}>URGENCE</div>
                    <div style={{ color: '#204385', fontSize: '10px', fontWeight: 700, padding: '10px', textAlign: 'right' }}>EXPERTS</div>
                    <div style={{ color: '#94a3b8', fontSize: '10px', fontWeight: 700, padding: '10px', paddingBottom: '20px', alignSelf: 'end' }}>SUPPORT</div>
                    <div style={{ color: '#10b981', fontSize: '10px', fontWeight: 700, padding: '10px', paddingBottom: '20px', alignSelf: 'end', textAlign: 'right' }}>POTENTIEL</div>
                </div>
            </div>
            <div style={{ textAlign: 'center', marginTop: '10px', fontSize: '12px', color: '#64748b' }}>
                Cliquez sur un collaborateur pour ouvrir son radar de compétences.
            </div>
        </div>
    );
};

const infoAverage = (levels, ...keys) => {
    if (!levels || levels.length === 0) return 0;
    const total = levels.reduce((sum, lvl) => {
        let val = 0;
        for (const key of keys) {
            if (lvl[key] !== undefined && lvl[key] !== null) {
                val = lvl[key];
                break;
            }
        }
        return sum + val;
    }, 0);
    return total / levels.length;
};

export default Team4Box;
